import { get } from 'lodash'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.first_name'
  }),
  intl.formatMessage({
    id: 'table.last_name'
  }),
  intl.formatMessage({
    id: 'table.created'
  }),
  intl.formatMessage({
    id: 'table.level'
  }),
  intl.formatMessage({
    id: 'table.award_unit'
  }),
  intl.formatMessage({
    id: 'table.email_confirmation'
  }),
  intl.formatMessage({
    id: 'table.parent_approval'
  }),
  intl.formatMessage({
    id: 'table.payment'
  })
]

export const line = (data = []) =>
  data.map(item => {
    return {
      line: [
        get(item, 'participantPerson.globalId') ||
          get(item, 'participantPerson.id'),
        get(item, 'participantPerson.firstName'),
        get(item, 'participantPerson.lastName'),
        get(item, 'createdAt'),
        get(item, 'award.awardLevel.value'),
        get(item, 'organization.name'),
        get(item, 'participantPerson.isEmailConfirmed'),
        `${get(item, 'award.consentDeliveryType.translationText')} ${get(item, 'award.isConsentDeliveryConfirmed')}`,
        `${get(item, 'award.paymentState.translationText')} ${get(item, 'award.isPaymentConfirmed')} `
      ]
    }
  })
